import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=b3b2b5d2&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=b3b2b5d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b2b5d2",
  null
  
)

export default component.exports